import { render, staticRenderFns } from "./ingredientSelector.vue?vue&type=template&id=958191aa&scoped=true&"
import script from "./ingredientSelector.vue?vue&type=script&lang=js&"
export * from "./ingredientSelector.vue?vue&type=script&lang=js&"
import style0 from "./ingredientSelector.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ingredientSelector.vue?vue&type=style&index=1&id=958191aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "958191aa",
  null
  
)

export default component.exports